import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { ITransaction } from 'types/interfaces/ITypes'

type TransactionCache = Record<string, ITransaction[]>

interface TransactionCacheState {
  cache: TransactionCache
  getTransactions: (filter: string) => ITransaction[] | null
  setTransactions: (filter: string, transactions: ITransaction[]) => void
  clear: () => void
}

export const useTransactionCacheStore = create<TransactionCacheState>()(
  persist(
    (set, get) => ({
      cache: {},
      getTransactions: (filter) => get().cache[filter] ?? null,
      setTransactions: (filter, transactions) =>
        set(state => ({
          cache: {
            ...state.cache,
            [filter]: transactions
          }
        })),
      clear: () => set({ cache: {} })
    }),
    {
      name: 'transaction-cache',
      partialize: (state) => ({
        cache: state.cache
      }),
    }
  )
)
